import { createApp } from 'vue';
import { Quasar, Notify } from 'quasar';
import quasarLang from 'quasar/lang/en-US';
import VueApexCharts from 'vue3-apexcharts';
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);
app.use(router);
app.use(Quasar, {
  plugins: { Notify },
  lang: quasarLang
});
app.use(VueApexCharts);
app.mount('#app');
